import { render, staticRenderFns } from "./quick10.vue?vue&type=template&id=a8014884&"
import script from "./quick10.vue?vue&type=script&lang=js&"
export * from "./quick10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports